import React from "react";
import { MultiLevelBuilder, showToast } from "../../../../components";
import { buildCampaignConfig } from "../../../../components/MultiLevelBuilder/campaignConfig";

const MultiLevelBuilderList = () => {
  const campaignConfig = buildCampaignConfig();

  const handleSchedule = (step) => {
    showToast("Campaign Scheduled", "success");
    console.log("Campaign scheduled:", step);
  };

  return (
    <div className="flex flex-col flex-1 overflow-auto">
      <MultiLevelBuilder config={campaignConfig} onSchedule={handleSchedule} />
    </div>
  );
};

export default MultiLevelBuilderList;
